import React, { Component } from 'react'
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
import { addReminder } from '../../actions';

import ReminderList from './ReminderList';

import '../../stylesheets/reminder.css'


class Reminder extends Component {
 constructor(props){
     super(props);
     this.state={
         text: '',
         dueDate:'',
         error:null,
         inputValue:''
     }
 }

 componentDidMount() {
    window.$('[data-toggle="tooltip"]').tooltip();
  }
  
  componentDidUpdate() {
    window.$('[data-toggle="tooltip"]').tooltip();
  }

  onChangeHandler(type,value){
    //console.log('log',type,value);
    this.setState({error:null});
    if(value!==''){
        if(type==='text'){
            this.setState({text:value});
        }else{
            this.setState({dueDate:value});
        }
    }
  }
  clear(){
    // console.log(this.state);
    this.inputText.value='';
    this.inputDate.value='';
    this.setState({text:'',dueDate:''});
  }

  getTodaysDate(){
    let date = new Date(); // current date
    let month = date.getMonth()+1;
    month = month <10 ? '0'+month : month
    let day = date.getDate();
    day = day <10 ? '0'+day : day
    date = date.getFullYear()+'-'+month+'-'+day+'T'+date.getHours()+':'+date.getMinutes();
    return date;
}
  checkError(){
    let {text,dueDate} = this.state;
    let res = false;
    if(text===''){
        this.setState({error:{type:'text',msg:'empty'}});
        res=true;
    }
    if (dueDate===''){
        this.setState({error:{type:'date',msg:'empty'}});
        res=true;
    }
    if(text==='' && dueDate===''){
        this.setState({error:{type:'both',msg:'empty'}});
        res=true;
    }
    return res;
  }

  onClickHandler(){
    
    if(!this.checkError()){
        this.add();
    }
    //console.log(this.state);
       
    
  }

  errorMessage(){
    let {error} = this.state;
    const danger={
        color:'red',
        fontSize:'0.5em',
    }
    let msg='';
    if( error!==null) {
        if(error.type==='text') msg = 'This cannot be empty.'
        if(error.type==='date') msg = 'Enter a valid date & time'
        if(error.type==='both') msg = 'Fields cannot be empty'
    }
    return(
        <div style={danger} className='col'> 
           {msg}
        </div>
    )
}

 inputForm(){
    let checkDanger=(this.state.error!=null)?this.state.error.type:null;
    
    //console.log(checkDanger);
    return(
        <div className='row'>
            <div className='col-sm-6'>
                <div className='form-group'>
                    <input type='text' 
                    className={`form-control ${(checkDanger==='text'|| checkDanger==='both')?'input-danger':''}`}
                    placeholder='I have to....'
                    onChange={event=>this.onChangeHandler('text',event.target.value)}
                    //value={this.state.inputValue}
                    ref={el => this.inputText = el}
                    />
                </div>
            </div>
            <div className='col-sm-4'>
                <div className='form-group'>
                    <input 
                    type='datetime-local' 
                    className={`form-control ${(checkDanger==='date'|| checkDanger==='both')?'input-danger':''}`}
                    onChange={event=>this.onChangeHandler('date',event.target.value)}
                    // value={this.state.inputValue}
                    ref={el => this.inputDate = el}
                    min={this.getTodaysDate()}
                    />
                </div>
            </div>
            <div className='col-sm-2 btn-col'>
                <div className='form-group'>
                    <button 
                    className='btn btn-success my-btn'
                    onClick={()=>this.onClickHandler()}
                    disabled={checkDanger!==null?'disabled':''}><i className='fa fa-plus'></i></button>
                    <button 
                    data-toggle='tooltip' 
                    title="Clear" 
                    className='btn btn-warning my-btn'
                    onClick={()=>this.clear()}
                    disabled={(this.state.text!=='' || this.state.dueDate!=='') ? null : 'disabled'}>
                    <i className='fa fa-backspace'></i></button>
                </div>
            </div>
            
        </div>
        
    )
}

  add(){
    //console.log(this.state);
    this.props.addReminder(this.state.text,this.state.dueDate);
  }

  render() {
    
    let checkDanger=(this.state.error!=null);
        //console.log('this.props',this.props);
    return (
      <div className='App container'>
        <h1>Reminder Pro</h1>
        
        {this.inputForm()}
        {(checkDanger)?this.errorMessage():null}
        {/* {(!checkDanger)?<ReminderList reminders={this.props.reminders}/>:null} */}
        <ReminderList reminders={this.props.reminders} />
        
       
      </div>
    )
  }
}


// function mapDispatchToProps(dispatch){
//     return bindActionCreators({addReminder},dispatch);
// }

// export default connect(null,mapDispatchToProps)(Reminder);

function mapStateToProps(state){
    let {reminders} = state;
    return {reminders};
}

export default connect(mapStateToProps,{addReminder})(Reminder);


// WEBPACK FOOTER //
// ./src/components/reminder/Reminder.jsx